module.exports = __webpack_public_path__ + "img/image-missing.87b4129c.jpg";